import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const ProfileComponent = lazy(() => import('./profile.tsx'));

export const profileRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <ProfileComponent />
      </Suspense>
    )
  }
];
